import { useRef } from 'react';
import { Slider, Slide, ResponsiveImage, Scroll } from 'components';
import { catList, imageSizes } from 'constants';
import { ButtonsList } from '../intendedComponents';

const Prac07 = () => {
  const itemsRef = useRef(null);

  const kittens = catList(10);

  function scrollToId(itemId) {
    const map = getMap();
    const node = map.get(itemId);
    node.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  function getMap() {
    if (!itemsRef.current) {
      itemsRef.current = new Map();
    }

    return itemsRef.current;
  }

  return (
    <>
      <Slider>
        {kittens.map(kitten => (
          <Slide
            key={kitten.id}
            slideRef={node => {
              const map = getMap();
              if (node) {
                map.set(kitten.id, node);
              } else {
                map.delete(kitten.id);
              }
            }}
          >
            <ResponsiveImage
              isLazy="lazy"
              image320={`kittens/${kitten.image320}`}
              image640={`kittens/${kitten.image640}`}
              image960={`kittens/${kitten.image960}`}
              image1280={`kittens/${kitten.image1280}`}
              sizes={imageSizes}
              alt={`Kittens ${(kitten.id + 1).toString().padStart(2, '0')}`}
            />
          </Slide>
        ))}
      </Slider>
      <Scroll>
        <ButtonsList kittens={kittens} scrollToId={scrollToId} />
      </Scroll>
    </>
  );
};

export default Prac07;
